import { call, put, takeLatest } from "redux-saga/effects";
import actionCreators from "../../actions/top/follow_circle_list";
import "babel-polyfill";

function* fetchCircles() {
  try {
    const data = yield call(function() {
      const method = "GET";
      const credentials = "include";
      const mode = "no-cors";
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };
      return fetch("/api/mypage/follow_circles", {
        method,
        credentials,
        mode,
        headers,
      })
        .then((response) => response.json())
        .catch((xhr) => {
          throw xhr.status;
        });
    });
    yield put(
      actionCreators.top.followcircles.success({
        followCircles: data.users_circles,
      })
    );
  } catch (e) {
    yield put(actionCreators.top.followcircles.failure(e));
  }
}

export default function*() {
  yield takeLatest(actionCreators.top.followcircles.set, fetchCircles);
}
